var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{attrs:{"isTransparent":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" تنظیمات وبسایت ")]},proxy:true}])},[_c('CallPriceSetting'),_c('PopularMasterSetting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }